<template>
  <div class="report__container">
    <div class="report__filter">
      <div class="filter-header">FILTERS</div>
      <slot name="filter"></slot>
    </div>
    <div class="report__content">
      <slot name="content"></slot>
    </div>
  </div>
</template>

<script>
export default {
  mounted() {
    const body = document.querySelector('body');
    if (body) {
      body.style.overflow = 'hidden';
    }
  },
  beforeDestroy() {
    const body = document.querySelector('body');
    if (body) {
      body.style.overflow = 'auto';
    }
  },
}
</script>

<style lang="scss" scoped>
  .report__container {
    width: 100%;
    height: 100%;
    display: flex;
  }

  .report__filter {
    min-width: 250px;
    max-width: 250px;
    display: flex;
    flex-direction: column;
    padding: 10px;
    height: calc(100vh - 100px);
    border-right: solid 1px gray;
  }

  .report__content {
    height: calc(100vh - 100px);
    width: 100%;
  }

  .filter-header {
    margin-bottom: 20px;
    border-bottom: solid 1px gray;
    font-weight: bold;
  }
</style>